
        require('./index.scss');
        'use strict';

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $ = window.$;
var win = $(window);
var _module = {
    init: function init() {
        var link = $('.next-article').find('a');
        $(window).scroll(function () {
            if (win.scrollTop() + win.height() >= window.document.body.scrollHeight) {
                // window.location.href = link.attr('href');
            }
        });
        this.getNextItem();
    },
    getNextItem: function getNextItem() {
        var id = $('.next-article').attr('data-id');
        var cache = JSON.parse(window.sessionStorage.getItem('list'));
        if (cache && cache.length && id) {
            var nextItem = this.find(cache, id);
            this.setDom(nextItem);
        } else {
            this.update(id);
        }
    },
    setDom: function setDom(item) {
        var title = item.title,
            url = item.url;

        if (title && url) {
            $('#nextLink').attr('href', url);
            $('#nextTitle').text('\u300C' + title + '\u300D');
        } else {
            $('.next-article').remove();
        }
    },
    find: function find(data, id) {
        var i = 0;
        for (; i < data.length; i++) {
            if (data[i].id == id) {
                break;
            }
        }
        if (i + 1 < data.length) {
            return data[i + 1];
        }
        if (i + 1 === data.length) {
            return {};
        }
        return data[0];
    },
    update: function update(id) {
        var that = this;
        var category = $('.next-article').attr('data-cate');
        // fetch(`/api/news/getLatestNews?newsId=${id}&category=${category}`, {method: 'GET'})
        //     .then((res) => res && res.json())
        //     .then((res) => {
        //         console.log(res);
        //         if (res && res.code == '200' && res.data && res.data.length) {
        //             const { data } = res;
        //             window.sessionStorage.setItem('list', JSON.stringify(data));
        //             const nextItem = data[0];
        //             that.setDom(nextItem);
        //         }
        //     })
        $.ajax('/api/news/getLatestNews?newsId=' + id + '&category=' + category).done(function (res) {
            if (res.code && res.code == '200') {
                res.data && res.data.length && window.sessionStorage.setItem('list', (0, _stringify2['default'])(res.data));
                var nextItem = res.data[0];
                that.setDom(nextItem);
            }
        });
    }
};
$(document).ready(setTimeout(_module.init(), 3000));;
    


// WEBPACK FOOTER //
// ./src/module/home-detail/next/index.js